import { FirebaseError } from "firebase/app";

export default function errorHandler(error) {
  if (error instanceof FirebaseError) {
    switch (error.code) {
      case "auth/invalid-email":
      case "auth/email-already-in-use":
        return "Invalid email or password.";
      case "auth/user-disabled":
        return "This account has been disabled.";
      case "auth/user-not-found":
      case "auth/wrong-password":
        return "Invalid email or password.";
      case "auth/weak-password":
        return "Password should be at least 6 characters.";
      default:
        return "An error occurred. Please try again later.";
    }
  }

  return "An error occurred. Please try again later.";
}
